import { Box, Typography, useTheme } from "@mui/material";

export default function CustomChip(props) {
  const { label, wrapperSX, typographySX, color } = props;
  const theme = useTheme();
  return (
    <Box
      sx={{
        background:
          color && theme.palette[color.toLowerCase()]?.main
            ? theme.palette[color.toLowerCase()].main
            : "#383838",
        color:
          color && theme.palette[color.toLowerCase()]?.contrastText
            ? theme.palette[color.toLowerCase()].contrastText
            : "#FFFFFF",
        border: "2px solid #FFFFFF",
        borderRadius: "4px",
        display: "flex",
        width: "fit-content",
        p: 1,
        ...wrapperSX,
      }}
    >
      <Typography
        variant="caption"
        color="inherit"
        sx={{
          mb: 0,
          fontFamily: "'Inter'",
          fontStyle: "normal",
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "19px",
          display: "flex",
          alignItems: "center",
          ...typographySX,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
